import React, { useMemo } from 'react';
import { ProviderComponentProps } from '../../types/api';

interface WindcavePayload {
  url: string;
}

const WindcaveProvider: React.FC<ProviderComponentProps> = ({ payloadBase64 }) => {
  const url = useMemo(() => {
    try {
      const decoded = JSON.parse(atob(payloadBase64));
      return decoded.Url || decoded.url;
    } catch {
      console.error('Failed to decode Windcave payload');
      return '';
    }
  }, [payloadBase64]);

  if (!url) {
    return (
      <div className="text-red-600 text-center py-4">
        Failed to load payment form.
      </div>
    );
  }

  return (
    <iframe
      src={url}
      className="w-full h-[460px] border-0 rounded-lg"
      frameBorder={0}
      title="Windcave Payment Form"
    />
  );
};

export default WindcaveProvider;
